import Model, { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  SmartInsightsPropertyTagsSubscription,
  SmartInsightsPropertyTagsUser,
} from 'lumen/models';

export default class SmartInsightsPropertyTagsModel extends Model {
  [Type] = 'smart-insights/property-tags' as const;

  @belongsTo('smart-insights/property-tags/user', {
    async: false,
    inverse: null,
  })
  declare dorm: SmartInsightsPropertyTagsUser | null;

  @belongsTo('smart-insights/property-tags/user', {
    async: false,
    inverse: null,
  })
  declare regionalDos: SmartInsightsPropertyTagsUser | null;

  @belongsTo('smart-insights/property-tags/user', {
    async: false,
    inverse: null,
  })
  declare regionalVp: SmartInsightsPropertyTagsUser | null;

  @belongsTo('smart-insights/property-tags/subscription', {
    async: false,
    inverse: null,
  })
  declare subscription: SmartInsightsPropertyTagsSubscription;
}
